import { paramCase } from 'src/utils/change-case';

import { _id, _postTitles } from 'src/_mock/assets';

// ----------------------------------------------------------------------

const MOCK_ID = _id[1];

const MOCK_TITLE = _postTitles[2];

export const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/error/403',
  page404: '/error/404',
  page500: '/error/500',
  components: '/components',
  docs: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
  zoneStore: 'https://mui.com/store/items/zone-landing-page/',
  minimalStore: 'https://mui.com/store/items/minimal-dashboard/',
  freeUI: 'https://mui.com/store/items/minimal-dashboard-free/',
  figma: 'https://www.figma.com/design/cAPz4pYPtQEXivqe11EcDE/%5BPreview%5D-Minimal-Web.v6.0.0',
  product: {
    root: `/product`,
    checkout: `/product/checkout`,
    details: (id) => `/product/${id}`,
    demo: { details: `/product/${MOCK_ID}` },
  },
  post: {
    root: `/post`,
    details: (title) => `/post/${paramCase(title)}`,
    demo: { details: `/post/${paramCase(MOCK_TITLE)}` },
  },
  // AUTH
  auth: {
    amplify: {
      signIn: `${ROOTS.AUTH}/amplify/sign-in`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      signUp: `${ROOTS.AUTH}/amplify/sign-up`,
      updatePassword: `${ROOTS.AUTH}/amplify/update-password`,
      resetPassword: `${ROOTS.AUTH}/amplify/reset-password`,
    },
    jwt: {
      signIn: `${ROOTS.AUTH}/jwt/sign-in`,
      signUp: `${ROOTS.AUTH}/jwt/sign-up`,
    },
    firebase: {
      signIn: `${ROOTS.AUTH}/firebase/sign-in`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      signUp: `${ROOTS.AUTH}/firebase/sign-up`,
      resetPassword: `${ROOTS.AUTH}/firebase/reset-password`,
    },
    auth0: {
      signIn: `${ROOTS.AUTH}/auth0/sign-in`,
    },
    supabase: {
      signIn: `${ROOTS.AUTH}/supabase/sign-in`,
      verify: `${ROOTS.AUTH}/supabase/verify`,
      signUp: `${ROOTS.AUTH}/supabase/sign-up`,
      updatePassword: `${ROOTS.AUTH}/supabase/update-password`,
      resetPassword: `${ROOTS.AUTH}/supabase/reset-password`,
    },
  },
  authDemo: {
    split: {
      signIn: `${ROOTS.AUTH_DEMO}/split/sign-in`,
      signUp: `${ROOTS.AUTH_DEMO}/split/sign-up`,
      resetPassword: `${ROOTS.AUTH_DEMO}/split/reset-password`,
      updatePassword: `${ROOTS.AUTH_DEMO}/split/update-password`,
      verify: `${ROOTS.AUTH_DEMO}/split/verify`,
    },
    centered: {
      signIn: `${ROOTS.AUTH_DEMO}/centered/sign-in`,
      signUp: `${ROOTS.AUTH_DEMO}/centered/sign-up`,
      resetPassword: `${ROOTS.AUTH_DEMO}/centered/reset-password`,
      updatePassword: `${ROOTS.AUTH_DEMO}/centered/update-password`,
      verify: `${ROOTS.AUTH_DEMO}/centered/verify`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    // mail: `${ROOTS.DASHBOARD}/mail`,
    // chat: `${ROOTS.DASHBOARD}/chat`,
    // blank: `${ROOTS.DASHBOARD}/blank`,
    // kanban: `${ROOTS.DASHBOARD}/kanban`,
    // calendar: `${ROOTS.DASHBOARD}/calendar`,
    // fileManager: `${ROOTS.DASHBOARD}/file-manager`,
    // permission: `${ROOTS.DASHBOARD}/permission`,
    general: {
      app: `${ROOTS.DASHBOARD}/app`,
      ecommerce: `${ROOTS.DASHBOARD}/ecommerce`,
      analytics: `${ROOTS.DASHBOARD}/analytics`,
      banking: `${ROOTS.DASHBOARD}/banking`,
      booking: `${ROOTS.DASHBOARD}/booking`,
      file: `${ROOTS.DASHBOARD}/file`,
      course: `${ROOTS.DASHBOARD}/course`,
    },
    user: {
      root: `${ROOTS.DASHBOARD}/user`,
      new: `${ROOTS.DASHBOARD}/user/new`,
      list: `${ROOTS.DASHBOARD}/user/list`,
      cards: `${ROOTS.DASHBOARD}/user/cards`,
      profile: `${ROOTS.DASHBOARD}/user/profile`,
      account: `${ROOTS.DASHBOARD}/user/account`,
      roles: `${ROOTS.DASHBOARD}/user/roles`,
      edit: (id) => `${ROOTS.DASHBOARD}/user/${id}/edit`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/user/${MOCK_ID}/edit`,
      },
    },
    games: {
      root: `${ROOTS.DASHBOARD}/games`,
      list: `${ROOTS.DASHBOARD}/games/list`,
      new: `${ROOTS.DASHBOARD}/games/new`,
      details: (id) => `${ROOTS.DASHBOARD}/games/${id}`,
    },
    gameConfiguration: {
      root: `${ROOTS.DASHBOARD}/games-configuration`,
      list: `${ROOTS.DASHBOARD}/games-configuration/list`,
      external: `${ROOTS.DASHBOARD}/games-configuration/external`,
      new: `${ROOTS.DASHBOARD}/games-configuration/new`,
      details: (id) => `${ROOTS.DASHBOARD}/games-configuration/${id}`,
    },
    featureConfiguration: {
      root: `${ROOTS.DASHBOARD}/feature-configuration`,
      bonusBuy: `${ROOTS.DASHBOARD}/feature-configuration/bonus-buy`,
      anteBet: `${ROOTS.DASHBOARD}/feature-configuration/ante-bet`,
      new: `${ROOTS.DASHBOARD}/feature-configuration/new`,
      details: (id) => `${ROOTS.DASHBOARD}/feature-configuration/${id}`,
    },
    clientConfiguration: {
      root: `${ROOTS.DASHBOARD}/client-configuration`,
      list: `${ROOTS.DASHBOARD}/client-configuration/list`,
      loader: `${ROOTS.DASHBOARD}/client-configuration/loader`,
      new: `${ROOTS.DASHBOARD}/client-configuration/new`,
      details: (id) => `${ROOTS.DASHBOARD}/client-configuration/${id}`,
    },
    jackpotConfiguration: {
      root: `${ROOTS.DASHBOARD}/jackpot-configuration`,
      list: `${ROOTS.DASHBOARD}/jackpot-configuration/list`,
      details: (id) => `${ROOTS.DASHBOARD}/jackpot-configuration/${id}`,

      liquidityPools: {
        root: `${ROOTS.DASHBOARD}/jackpot-configuration/liquidity-pools`,
        list: `${ROOTS.DASHBOARD}/jackpot-configuration/liquidity-pools/list`,
      },
      groups: {
        root: `${ROOTS.DASHBOARD}/jackpot-configuration/groups`,
        list: `${ROOTS.DASHBOARD}/jackpot-configuration/groups/list`,
        details: (id) => `${ROOTS.DASHBOARD}/jackpot-configuration/groups/${id}`,
      },
    },
    gameHistory: {
      root: `${ROOTS.DASHBOARD}/game-history`,

      openedSessions: {
        root: `${ROOTS.DASHBOARD}/game-history/opened-sessions`,
        list: `${ROOTS.DASHBOARD}/game-history/opened-sessions/list`,
      },
      gameRoundHistory: {
        root: `${ROOTS.DASHBOARD}/game-history/game-round-history`,
        list: `${ROOTS.DASHBOARD}/game-history/game-round-history/list`,
      },
    },
    testing: {
      root: `${ROOTS.DASHBOARD}/testing`,

      rtpVerification: {
        root: `${ROOTS.DASHBOARD}/testing/rtp-verification`,
        list: `${ROOTS.DASHBOARD}/testing/rtp-verification/list`,
        details: (gameEngineId, gameId) =>
          `${ROOTS.DASHBOARD}/testing/rtp-verification/${gameEngineId}.${gameId}`,
      },
    },
    // binaries: {
    //   root: `${ROOTS.DASHBOARD}/gm`,
    //   list: `${ROOTS.DASHBOARD}/gm/binaries/list`,
    //   new: `${ROOTS.DASHBOARD}/gm/binaries/new`,
    //   details: (id) => `${ROOTS.DASHBOARD}/gm/binaries/${id}`,
    // },
    // engines: {
    //   root: `${ROOTS.DASHBOARD}/gm`,
    //   list: `${ROOTS.DASHBOARD}/gm/engines/list`,
    //   new: `${ROOTS.DASHBOARD}/gm/engines/new`,
    //   details: (id) => `${ROOTS.DASHBOARD}/gm/engines/${id}`,
    // },
    operators: {
      root: `${ROOTS.DASHBOARD}/operators`,
      list: `${ROOTS.DASHBOARD}/operators/list`,
      new: `${ROOTS.DASHBOARD}/operators/new`,
      details: (id) => `${ROOTS.DASHBOARD}/operators/${id}`,
    },
    // invoice: {
    //   root: `${ROOTS.DASHBOARD}/invoice`,
    //   new: `${ROOTS.DASHBOARD}/invoice/new`,
    //   details: (id) => `${ROOTS.DASHBOARD}/invoice/${id}`,
    //   edit: (id) => `${ROOTS.DASHBOARD}/invoice/${id}/edit`,
    //   demo: {
    //     details: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}`,
    //     edit: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}/edit`,
    //   },
    // },
    // post: {
    //   root: `${ROOTS.DASHBOARD}/post`,
    //   new: `${ROOTS.DASHBOARD}/post/new`,
    //   details: (title) => `${ROOTS.DASHBOARD}/post/${paramCase(title)}`,
    //   edit: (title) => `${ROOTS.DASHBOARD}/post/${paramCase(title)}/edit`,
    //   demo: {
    //     details: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}`,
    //     edit: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}/edit`,
    //   },
    // },
    // order: {
    //   root: `${ROOTS.DASHBOARD}/order`,
    //   details: (id) => `${ROOTS.DASHBOARD}/order/${id}`,
    //   demo: {
    //     details: `${ROOTS.DASHBOARD}/order/${MOCK_ID}`,
    //   },
    // },
    // job: {
    //   root: `${ROOTS.DASHBOARD}/job`,
    //   new: `${ROOTS.DASHBOARD}/job/new`,
    //   details: (id) => `${ROOTS.DASHBOARD}/job/${id}`,
    //   edit: (id) => `${ROOTS.DASHBOARD}/job/${id}/edit`,
    //   demo: {
    //     details: `${ROOTS.DASHBOARD}/job/${MOCK_ID}`,
    //     edit: `${ROOTS.DASHBOARD}/job/${MOCK_ID}/edit`,
    //   },
    // },
    // tour: {
    //   root: `${ROOTS.DASHBOARD}/tour`,
    //   new: `${ROOTS.DASHBOARD}/tour/new`,
    //   details: (id) => `${ROOTS.DASHBOARD}/tour/${id}`,
    //   edit: (id) => `${ROOTS.DASHBOARD}/tour/${id}/edit`,
    //   demo: {
    //     details: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}`,
    //     edit: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}/edit`,
    //   },
    // },
  },
};

// export const demoPaths = {
//   comingSoon: '/coming-soon',
//   maintenance: '/maintenance',
//   pricing: '/pricing',
//   payment: '/payment',
//   about: '/about-us',
//   contact: '/contact-us',
//   faqs: '/faqs',
//   page403: '/error/403',
//   page404: '/error/404',
//   page500: '/error/500',
//   components: '/components',
//   docs: 'https://docs.minimals.cc',
//   changelog: 'https://docs.minimals.cc/changelog',
//   zoneStore: 'https://mui.com/store/items/zone-landing-page/',
//   minimalStore: 'https://mui.com/store/items/minimal-dashboard/',
//   freeUI: 'https://mui.com/store/items/minimal-dashboard-free/',
//   figma: 'https://www.figma.com/design/cAPz4pYPtQEXivqe11EcDE/%5BPreview%5D-Minimal-Web.v6.0.0',
//   product: {
//     root: `/product`,
//     checkout: `/product/checkout`,
//     details: (id) => `/product/${id}`,
//     demo: { details: `/product/${MOCK_ID}` },
//   },
//   post: {
//     root: `/post`,
//     details: (title) => `/post/${paramCase(title)}`,
//     demo: { details: `/post/${paramCase(MOCK_TITLE)}` },
//   },
//   // AUTH
//   auth: {
//     amplify: {
//       signIn: `${ROOTS.AUTH}/amplify/sign-in`,
//       verify: `${ROOTS.AUTH}/amplify/verify`,
//       signUp: `${ROOTS.AUTH}/amplify/sign-up`,
//       updatePassword: `${ROOTS.AUTH}/amplify/update-password`,
//       resetPassword: `${ROOTS.AUTH}/amplify/reset-password`,
//     },
//     jwt: {
//       signIn: `${ROOTS.AUTH}/jwt/sign-in`,
//       signUp: `${ROOTS.AUTH}/jwt/sign-up`,
//     },
//     firebase: {
//       signIn: `${ROOTS.AUTH}/firebase/sign-in`,
//       verify: `${ROOTS.AUTH}/firebase/verify`,
//       signUp: `${ROOTS.AUTH}/firebase/sign-up`,
//       resetPassword: `${ROOTS.AUTH}/firebase/reset-password`,
//     },
//     auth0: {
//       signIn: `${ROOTS.AUTH}/auth0/sign-in`,
//     },
//     supabase: {
//       signIn: `${ROOTS.AUTH}/supabase/sign-in`,
//       verify: `${ROOTS.AUTH}/supabase/verify`,
//       signUp: `${ROOTS.AUTH}/supabase/sign-up`,
//       updatePassword: `${ROOTS.AUTH}/supabase/update-password`,
//       resetPassword: `${ROOTS.AUTH}/supabase/reset-password`,
//     },
//   },
//   authDemo: {
//     split: {
//       signIn: `${ROOTS.AUTH_DEMO}/split/sign-in`,
//       signUp: `${ROOTS.AUTH_DEMO}/split/sign-up`,
//       resetPassword: `${ROOTS.AUTH_DEMO}/split/reset-password`,
//       updatePassword: `${ROOTS.AUTH_DEMO}/split/update-password`,
//       verify: `${ROOTS.AUTH_DEMO}/split/verify`,
//     },
//     centered: {
//       signIn: `${ROOTS.AUTH_DEMO}/centered/sign-in`,
//       signUp: `${ROOTS.AUTH_DEMO}/centered/sign-up`,
//       resetPassword: `${ROOTS.AUTH_DEMO}/centered/reset-password`,
//       updatePassword: `${ROOTS.AUTH_DEMO}/centered/update-password`,
//       verify: `${ROOTS.AUTH_DEMO}/centered/verify`,
//     },
//   },
//   // DASHBOARD
//   dashboard: {
//     root: ROOTS.DEMO_DASHBOARD,
//     mail: `${ROOTS.DEMO_DASHBOARD}/mail`,
//     chat: `${ROOTS.DEMO_DASHBOARD}/chat`,
//     blank: `${ROOTS.DEMO_DASHBOARD}/blank`,
//     kanban: `${ROOTS.DEMO_DASHBOARD}/kanban`,
//     calendar: `${ROOTS.DEMO_DASHBOARD}/calendar`,
//     fileManager: `${ROOTS.DEMO_DASHBOARD}/file-manager`,
//     permission: `${ROOTS.DEMO_DASHBOARD}/permission`,
//     general: {
//       app: `${ROOTS.DEMO_DASHBOARD}/app`,
//       ecommerce: `${ROOTS.DEMO_DASHBOARD}/ecommerce`,
//       analytics: `${ROOTS.DEMO_DASHBOARD}/analytics`,
//       banking: `${ROOTS.DEMO_DASHBOARD}/banking`,
//       booking: `${ROOTS.DEMO_DASHBOARD}/booking`,
//       file: `${ROOTS.DEMO_DASHBOARD}/file`,
//       course: `${ROOTS.DEMO_DASHBOARD}/course`,
//     },
//     user: {
//       root: `${ROOTS.DEMO_DASHBOARD}/user`,
//       new: `${ROOTS.DEMO_DASHBOARD}/user/new`,
//       list: `${ROOTS.DEMO_DASHBOARD}/user/list`,
//       cards: `${ROOTS.DEMO_DASHBOARD}/user/cards`,
//       profile: `${ROOTS.DEMO_DASHBOARD}/user/profile`,
//       account: `${ROOTS.DEMO_DASHBOARD}/user/account`,
//       roles: `${ROOTS.DEMO_DASHBOARD}/user/roles`,
//       edit: (id) => `${ROOTS.DEMO_DASHBOARD}/user/${id}/edit`,
//       demo: {
//         edit: `${ROOTS.DEMO_DASHBOARD}/user/${MOCK_ID}/edit`,
//       },
//     },
//     product: {
//       root: `${ROOTS.DEMO_DASHBOARD}/product`,
//       new: `${ROOTS.DEMO_DASHBOARD}/product/new`,
//       details: (id) => `${ROOTS.DEMO_DASHBOARD}/product/${id}`,
//       edit: (id) => `${ROOTS.DEMO_DASHBOARD}/product/${id}/edit`,
//       demo: {
//         details: `${ROOTS.DEMO_DASHBOARD}/product/${MOCK_ID}`,
//         edit: `${ROOTS.DEMO_DASHBOARD}/product/${MOCK_ID}/edit`,
//       },
//     },
//     invoice: {
//       root: `${ROOTS.DEMO_DASHBOARD}/invoice`,
//       new: `${ROOTS.DEMO_DASHBOARD}/invoice/new`,
//       details: (id) => `${ROOTS.DEMO_DASHBOARD}/invoice/${id}`,
//       edit: (id) => `${ROOTS.DEMO_DASHBOARD}/invoice/${id}/edit`,
//       demo: {
//         details: `${ROOTS.DEMO_DASHBOARD}/invoice/${MOCK_ID}`,
//         edit: `${ROOTS.DEMO_DASHBOARD}/invoice/${MOCK_ID}/edit`,
//       },
//     },
//     post: {
//       root: `${ROOTS.DEMO_DASHBOARD}/post`,
//       new: `${ROOTS.DEMO_DASHBOARD}/post/new`,
//       details: (title) => `${ROOTS.DEMO_DASHBOARD}/post/${paramCase(title)}`,
//       edit: (title) => `${ROOTS.DEMO_DASHBOARD}/post/${paramCase(title)}/edit`,
//       demo: {
//         details: `${ROOTS.DEMO_DASHBOARD}/post/${paramCase(MOCK_TITLE)}`,
//         edit: `${ROOTS.DEMO_DASHBOARD}/post/${paramCase(MOCK_TITLE)}/edit`,
//       },
//     },
//     order: {
//       root: `${ROOTS.DEMO_DASHBOARD}/order`,
//       details: (id) => `${ROOTS.DEMO_DASHBOARD}/order/${id}`,
//       demo: {
//         details: `${ROOTS.DEMO_DASHBOARD}/order/${MOCK_ID}`,
//       },
//     },
//     job: {
//       root: `${ROOTS.DEMO_DASHBOARD}/job`,
//       new: `${ROOTS.DEMO_DASHBOARD}/job/new`,
//       details: (id) => `${ROOTS.DEMO_DASHBOARD}/job/${id}`,
//       edit: (id) => `${ROOTS.DEMO_DASHBOARD}/job/${id}/edit`,
//       demo: {
//         details: `${ROOTS.DEMO_DASHBOARD}/job/${MOCK_ID}`,
//         edit: `${ROOTS.DEMO_DASHBOARD}/job/${MOCK_ID}/edit`,
//       },
//     },
//     tour: {
//       root: `${ROOTS.DEMO_DASHBOARD}/tour`,
//       new: `${ROOTS.DEMO_DASHBOARD}/tour/new`,
//       details: (id) => `${ROOTS.DEMO_DASHBOARD}/tour/${id}`,
//       edit: (id) => `${ROOTS.DEMO_DASHBOARD}/tour/${id}/edit`,
//       demo: {
//         details: `${ROOTS.DEMO_DASHBOARD}/tour/${MOCK_ID}`,
//         edit: `${ROOTS.DEMO_DASHBOARD}/tour/${MOCK_ID}/edit`,
//       },
//     },
//   },
// };
